import axios from "axios";
import store from "../store/index";
import { logout, masterAuthClear } from "../store/login/index";
import toast from "react-hot-toast";

let cachedMasterToken = null;

// Update cachedMasterToken whenever Redux state changes
store.subscribe(() => {
  cachedMasterToken = store.getState().login?.masterAuthToken;
});

// Apply base URL for axios
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const API_VERSION = process.env.REACT_APP_API_VERSION;

const axiosApi = axios.create({
  baseURL: `${API_BASE_URL}${API_VERSION}`,
  headers: {
    "ngrok-skip-browser-warning": "69420",
  },
});

axiosApi.interceptors.request.use(
  (config) => {
    if (cachedMasterToken) {
      config.headers["x-master-token"] = `Bearer ${cachedMasterToken}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosApi.interceptors.response.use(
  (response) => response,
  (error) => {
    const err = error.response;
    if (err && err.status === 401) {
      handleLogout();
    }

    if (err && err.status === 403) {
      toast.error("You are not authorized to perform this action.", {
        id: 'apiError'
      })
      store.dispatch(masterAuthClear());
    } else {
      toast.error(err?.data?.message || "Network error!", {
        id: 'apiError'
      })
    }
    
    return Promise.reject(error);
  }
);

export const updateToken = (token) => {
  if (token) {
    axiosApi.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    delete axiosApi.defaults.headers.common["Authorization"];
  }
};

const handleLogout = () => {
  store.dispatch(logout());
  localStorage.clear();
  window.location.replace("/");
};

const token = store?.getState()?.login?.token;
updateToken(token);

export async function get(url) {
  try {
    const response = await axiosApi.get(url);
    return handleResponse(response);
  } catch (error) {
    return handleErrorResponse(error);
  }
}

export async function post(url, data) {
  try {
    const response = await axiosApi.post(url, data);
    return handleResponse(response);
  } catch (error) {
    return handleErrorResponse(error);
  }
}

export async function put(url, data) {
  try {
    const response = await axiosApi.put(url, data);
    return handleResponse(response);
  } catch (error) {
    return handleErrorResponse(error);
  }
}

export async function del(url) {
  try {
    const response = await axiosApi.delete(url);
    return handleResponse(response);
  } catch (error) {
    return handleErrorResponse(error);
  }
}

const handleResponse = (response) => {
  if (response.data.status === "failure") {
    if (response.data.isInvalidToken) {
      handleLogout();
    } else if (
      response.data.message ===
      "Access denied. you didn't have permission to access this end point"
    ) {
      handleLogout();
    }
  }
  return response.data;
};

const handleErrorResponse = (error) => {
  // const err = error.response;
  // if (err && err.status === 401) {
  //   handleLogout();
  // }
  console.error("API call error", error);
  throw error;
};
